export default "__VITE_ASSET__DRDWiMNf__"